module.exports = __webpack_public_path__ + "img/PE_GG60_1920x1080.0a256792.webp";